var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function ShirtIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3C9.55228 3 10 3.44772 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4C14 3.44772 14.4477 3 15 3H20C21.1046 3 22 3.89543 22 5V8C22 9.10457 21.1046 10 20 10H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V10H4C2.89543 10 2 9.10457 2 8V5C2 3.89543 2.89543 3 4 3H9ZM4 5V8H5C6.10457 8 7 8.89543 7 10V19H17V10C17 8.89543 17.8954 8 19 8H20V5H15.874C15.4299 6.72523 13.8638 8 12 8C10.1362 8 8.57006 6.72523 8.12602 5H4Z", fill: "" })));
}
export var ShirtIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: ShirtIconInner }, props))); };
//# sourceMappingURL=ShirtIcon.js.map